import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=088809c4&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=ts"
export * from "./ModalBase.vue?vue&type=script&lang=ts"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=088809c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088809c4",
  null
  
)

export default component.exports